/*
 * File: /src/components/UIComponents/LoadingPlugin/index.js
 * Created Date: Thursday July 23rd 2020
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Thursday, 23rd July 2020 12:08:15 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2020 AdBase, Inc.
 */
import Loading from './Loading.vue';

const LoadingPlugin = {
  install(Vue, options) {
    Vue.component('send-loading', Loading);
  }
};

export default LoadingPlugin;
